enum Role {
  ADMIN_ENTERPRISE = 'admin_enterprise',
  ADMIN_ESTABLISHMENT = 'admin_establishment',
  EMPLOYEE_ESTABLISHMENT = 'employee_establishment',
  MANAGER_ESTABLISHMENT = 'manager_establishment',
}

export default Role;
